/**
 * Simple utility functions for generating universal links
 */

const BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'https://api.jst.scifree.se';

/**
 * Normalize key by keeping only alphanumeric characters and converting to lowercase
 */
function normalizeKey(key: string): string {
  return key.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

/**
 * Generate payment link: https://API/links/su:a:{journal_id}
 */
export function generatePaymentLink(journalId: string, orgSlug: string): string {
  if (!journalId) return '#';
  return `${BASE_URL}/links/${orgSlug}:a:${normalizeKey(journalId)}`;
}

/**
 * Generate license link: https://API/links/su:l:{license_key}:{locale}
 */
export function generateLicenseLink(licenseKey: string, locale: string, orgSlug: string): string {
  if (!licenseKey || !locale) return '#';
  return `${BASE_URL}/links/${orgSlug}:l:${normalizeKey(licenseKey)}:${normalizeKey(locale)}`;
}

/**
 * Generate publishing model link: https://API/links/su:m:{name}:{locale}
 */
export function generatePublishingModelLink(modelName: string, locale: string, orgSlug: string): string {
  if (!modelName || !locale) return '#';
  return `${BASE_URL}/links/${orgSlug}:m:${normalizeKey(modelName)}:${normalizeKey(locale)}`;
}

/**
 * Generate journal link: https://API/links/su:j:{journal_id}
 */
export function generateJournalLink(journalId: string, orgSlug: string): string {
  if (!journalId) return '#';
  return `${BASE_URL}/links/${orgSlug}:j:${normalizeKey(journalId)}`;
}

/**
 * Generate quality score link: https://API/links/su:q:{system}
 */
export function generateQualityLink(system: string, orgSlug: string): string {
  if (!system || !orgSlug) return '#';
  return `${BASE_URL}/links/${orgSlug}:q:${normalizeKey(system)}`;
}